module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-page-view"
  }, [_c('TopView', {
    attrs: {
      "topList": _vm.topList
    },
    on: {
      "switchTabIndex": _vm.switchTabIndex
    }
  }), _vm._v(" "), (_vm.currentTabIndex === 1) ? _c('VideoList', {
    ref: "videoList"
  }) : _vm._e(), _vm._v(" "), (_vm.currentTabIndex === 2) ? _c('VideoByMeList', {
    ref: "videoByMeList",
    on: {
      "resetCurrentPage": _vm.resetCurrentPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentTabIndex === 3) ? _c('TransmitList', {
    ref: "transmitList",
    on: {
      "resetCurrentPage": _vm.resetCurrentPage
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5596652", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5596652"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/PlatformMainPage.vue
// module id = 1319
// module chunks = 1